import React from 'react';
import { Row, Col, Form, FormGroup, Label, Input, FormText } from 'reactstrap';
import './TagSection.css'
import { createTagDictionary } from '../models/tagDictionary';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { connect } from 'react-redux';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import HelpIcon from '@material-ui/icons/Help';
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';
import Popover from "@material-ui/core/Popover";
import Chip from '@material-ui/core/Chip';
import FaceIcon from '@material-ui/icons/Face';
import DoneIcon from '@material-ui/icons/Done';
import AddCircleOutlinedIcon from '@material-ui/icons/AddCircleOutlined';
import { cmsActions } from '../../../../store/actions/cms/cms.action';
import SystemLabel from '../../../../system/SystemLabel/SystemLabel';



function RecipeReviewCard(props) {
    const [expanded, setExpanded] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleExpandClick = () => {
        setExpanded(!expanded);
    };
    const handleClick = event => {
        setAnchorEl(event.currentTarget);
        props.dispatch(cmsActions.blockDeselect(true))
        //load all colors from template
    };
    const handleClose = () => {
        setAnchorEl(null);
        setTimeout(() => props.dispatch(cmsActions.blockDeselect(false)), 2000)
    };
    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;
    return (
        <Card className={'smooth-shadow'} style={{ marginTop: 5, background: expanded ? '#fff' : '#eee' }}>
            <CardHeader
                avatar={
                    <Avatar aria-label="recipe" style={{ background: expanded ? 'rgb(23, 162, 184)' : '#bdbdbd', padding: '10px 16px' }} /* className={classes.avatar} */>
                        {props.icon}
                    </Avatar>
                }
                action={
                    <React.Fragment>
                        {/* {expanded ? <IconButton
                            aria-expanded={open}
                            onClick={handleClick}
                            aria-label="show more">
                            <HelpOutlineOutlinedIcon style={{ color: expanded ? 'rgba(0, 0, 0, 0.54)' : '#bdbdbd', }} />
                        </IconButton> : null} */}
                        <IconButton onClick={handleExpandClick}
                            aria-expanded={expanded}
                            aria-label="show more">
                            <ExpandMoreIcon style={{
                                transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                                transition: 'transform 0.5s'
                            }} />
                        </IconButton>
                    </React.Fragment>
                }
                style={{ textAlign: 'left', padding: '10px 16px' }}
                title={<SystemLabel name={props.groupName} />}
            />
            <Popover
                id={id}
                open={open}
                className="tag-tooltip-pop"
                anchorEl={anchorEl}
                onClose={handleClose}
                style={{ zIndex: 10000, padding: "10px" }}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center"
                }}
            >
                {props.tooltipComponent}
            </Popover>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <CardContent>
                    {props.children}
                </CardContent>
            </Collapse>
        </Card>
    );
}

function mapStateToProps(state) {
    return state
}
export default connect(mapStateToProps)(RecipeReviewCard);